<template>
    <el-dialog class="common-dialog noHeader register-info-dialog" title="设置一个私人密码" :visible="isShowModal"
               :show-close="false" @open="passOpen()">
        <div class="title">
            <h3>设置密码后，可直接通过手机号、密码快速登录</h3>
        </div>
        <div class="content">
            <el-form :model="passwordForm" :rules="rules" ref="passwordForm" class="loginForm">
                <el-form-item prop="password">
                    <el-input type="password" v-model="passwordForm.password" placeholder="请输入常用密码"></el-input>
                </el-form-item>
                <el-form-item prop="passwordCompare">
                    <el-input type="password" v-model="passwordForm.passwordCompare" placeholder="确认密码"></el-input>
                </el-form-item>
                <el-button type="primary" size="full" :loading="btnLoading" @click="saveUser()">完 成</el-button>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
    data() {
        return {
            passwordForm: {
                password: '',
                passwordCompare: ''
            },
            rules: {
                password: [
                    { required: true, message: '请输入新密码', trigger: 'blur' }
                    // { validator: this.passwordCompareValidator, bothNoEmpty:true, trigger: 'change' }
                ],
                passwordCompare: [
                    { validator: this.passwordCompareValidator, trigger: 'change' }
                ]
            },
            btnLoading: false
        }
    },
    computed: {
        ...mapState(['loginStep', 'user']),
        ...mapState('company', ['company']),
        isShowModal() {
            return this.loginStep === 'password';
        }
    },
    methods: {
        ...mapMutations(['setUserInfo', 'closeLoginDialog']),
        ...mapActions(['registerUser']),
        ...mapActions('welfare',['getTypeLog']),
        passOpen() {
            for (let key in this.passwordForm) {
                if (this.passwordForm.hasOwnProperty(key)) {
                    this.passwordForm[key] = '';
                }
            }
        },
        passwordCompareValidator(rule, value, callback) {
            if (this.passwordForm.password !== this.passwordForm.passwordCompare) {
                callback(new Error('密码两次输入不相同'));
            } else {
                callback();
            }
        },
        //提交注册
        saveUser() {
            this.btnLoading = true;
            this.$refs['passwordForm'].validate(valid => {
                if (valid) {
                    this.setUserInfo({password: this.passwordForm.password});
                    this.registerUser(this.company).then(() => {
                        this.$message({ type: 'success', message: '恭喜！注册成功' });
                        this.getTypeLog();
                        this.closeLoginDialog();
                        setTimeout(() => {this.btnLoading = false}, 1000);
                    }, error => {
                        this.btnLoading = false;
                        this.$message({ type: 'error', message: error });
                    });
                } else {
                    this.btnLoading = false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.title {
    $lineHeight: 24;
    position: relative;
    text-align: center;
    h3 {
        position: relative;
        font-size: 0.8rem;
        margin: 0;
        &::before {
            content: '';
            position: absolute;
            width: 6.25rem;
            border-bottom: 1px solid #d3e3fa;
            top: 0.5rem;
            left: 0;
        }
        &::after {
            content: '';
            position: absolute;
            width: 6.25rem;
            border-bottom: 1px solid #d3e3fa;
            top: 0.5rem;
            right: 0;
        }
    }
}

.content {
    height: 12.9rem;
    margin-top: 2rem;
    position: relative;

    .el-button {
        margin-top: 2rem;
    }

    .el-input {
        height: 48px;
        line-height: 48px;
    }
}
</style>



// WEBPACK FOOTER //
// app/view/login/LoginPassword.vue